import { fetchWithAuth } from './utils';

export async function getAddress() {
  const url = new URL(`${process.env.REACT_APP_API_URL}/address/get`);

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch device list:', error);
    throw error;
  }
};

export async function getAddressForm(type_device) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/group`);
    
    url.searchParams.append('type_device', type_device);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function createAddress(values) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/create`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(values)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function editAddressById(id, values) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/edit`);
    url.searchParams.append('id', id);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(values)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function getAddressById(id) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/edit`);
    url.searchParams.append('id', id);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function getAddressByGroupId(id) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/getByIdGroup`);
    url.searchParams.append('id', id);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function getAddressList() {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/list`);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}


export async function deleteAddressById(id) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/address/delete`);
    url.searchParams.append('_id', id);

    const response = await fetchWithAuth(url, {
        method: 'POST'
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to delete the address');
    }

    return await response.json();
}